module.exports = __webpack_public_path__ + "assets/img/panorama-vr1.ee96ff7b.png";